#import "../downtimeBlock/downtimeBlockInfo.gql"
#import "../workBlock/workBlockInfo.gql"

query GetAllBlocks($startsAt: ISO8601DateTime, $endsAt: ISO8601DateTime) {
  blocks(startsAt: $startsAt, endsAt: $endsAt) @connection(key: "blocks") {
    workBlocks {
      ...workBlockInfo
    }
    downtimeBlocks {
      ...downtimeBlockInfo
    }
  }
}

mutation RescheduleBlocks($workBlocks: [WorkBlockInput!], $downtimeBlocks: [DowntimeBlockInput!]) {
  rescheduleBlocks(workBlocks: $workBlocks, downtimeBlocks: $downtimeBlocks) {
    workBlocks {
      ...workBlockInfo
    }
    downtimeBlocks {
      ...downtimeBlockInfo
    }
  }
}

mutation CloseGap(
  $clickedTime: ISO8601DateTime!
  $startsAt: ISO8601DateTime!
  $endsAt: ISO8601DateTime!
  $lineId: ID!
) {
  closeGap(clickedTime: $clickedTime, startsAt: $startsAt, endsAt: $endsAt, lineId: $lineId) {
    blocks @connection(key: "blocks") {
      workBlocks {
        ...workBlockInfo
      }
      downtimeBlocks {
        ...downtimeBlockInfo
      }
    }
  }
}
